/* eslint-disable import/no-anonymous-default-export */
import dashboard from "../models/dashboard";

export const types = {
  CADD_DASHBOARD_REQUEST: "CADD_DASHBOARD_REQUEST",
  CADD_DASHBOARD_REQUEST_WITH_FILTERS: "CADD_DASHBOARD_REQUEST_WITH_FILTERS",
  CADD_DASHBOARD_SUCCESS: "CADD_DASHBOARD_SUCCESS",
  CADD_DASHBOARD_FAILED: "CADD_DASHBOARD_FAILED",
  PME_DASHBOARD_REQUEST: "PME_DASHBOARD_REQUEST",
  PME_DASHBOARD_REQUEST_WITH_FILTERS: "PME_DASHBOARD_REQUEST_WITH_FILTERS",
  PME_DASHBOARD_SUCCESS: "PME_DASHBOARD_SUCCESS",
  PME_DASHBOARD_FAILED: "PME_DASHBOARD_FAILED",
  PME_PROJECT_REQUEST: "PME_PROJECT_REQUEST",
  PME_PROJECT_REQUEST_WITH_FILTERS: "PME_PROJECT_REQUEST_WITH_FILTERS",
  PME_PROJECT_SUCCESS: "PME_PROJECT_SUCCESS",
  PME_PROJECT_FAILED: "PME_PROJECT_FAILED",
};

export const actions = {
  CaddDashboardGet: ({ isScpProject, selectedProject }) => ({
    type: types.CADD_DASHBOARD_REQUEST,
    isScpProject: isScpProject || false,
    selectedProject,
  }),
  PmeDashboardGet: (cb = () => { }) => ({
    type: types.PME_DASHBOARD_REQUEST,
    callback: cb
  }),
  PmeProjectGet: (cb = () => { }) => ({
    callback: cb,
    type: types.PME_PROJECT_REQUEST,
  }),
  PmeProjectGetWithFilters: (payload, cb = () => { }) => ({
    type: types.PME_PROJECT_REQUEST_WITH_FILTERS,
    payload,
    callback: cb,
  }),
  PmeDashboardGetWithFilters: (payload, cb = () => { }) => ({
    type: types.PME_DASHBOARD_REQUEST_WITH_FILTERS,
    payload,
    callback: cb,
  }),
  CaddDashboardGetWithFilters: (payload, cb = () => { }, isScpProject = false) => ({
    type: types.CADD_DASHBOARD_REQUEST_WITH_FILTERS,
    payload,
    callback: cb,
    isScpProject,
  }),
};

export default (state = dashboard, action) => {
  switch (action.type) {
    case types.CADD_DASHBOARD_REQUEST:
      return {
        ...state,
        cadd: {
          loading: true,
          retrived: false,
          data: {}
        }
      }
    case types.CADD_DASHBOARD_REQUEST_WITH_FILTERS:
      return {
        ...state,
        cadd: {
          ...state.cadd,
          data: {
            ...state.cadd.data,
            [action.payload.widget]: null,
          }
        }
      }
    case types.CADD_DASHBOARD_SUCCESS:
      return {
        ...state,
        cadd: {
          loading: false,
          retrieved: true,
          data: {
            ...state.cadd.data,
            ...action.value,
          },
        }
      }
    case types.PME_DASHBOARD_REQUEST:
      return {
        ...state,
        pme: {
          loading: true,
          retrived: false,
          data: {},
        },
      }
    case types.PME_PROJECT_REQUEST:
      return {
        ...state,
        pme: {
          loading: true,
          retrived: false,
          data: {},
        },
      }
    case types.PME_PROJECT_SUCCESS:
      return {
        ...state,
        pme: {
          loading: false,
          retrived: true,
          data: {
            ...state.pme.data,
            ...action.value,
          }
        },
      }
    case types.PME_DASHBOARD_REQUEST_WITH_FILTERS:
      if (action.payload.noReset) {
        return state;
      }
      return {
        ...state,
        pme: {
          ...state.pme,
          data: {
            ...state.pme.data,
            [action.payload.widget]: null,
          }
        }
      }
    case types.PME_PROJECT_REQUEST_WITH_FILTERS:
      if (action.payload.noReset) {
        return state;
      }

      let data;
      if (action.payload.secondWidget) {
        data = {
          ...state.pme.data,
          [action.payload.widget]: null,
          [action.payload.secondWidget]: null,
        };
      } else {
        data = {
          ...state.pme.data,
          [action.payload.widget]: null,
        };
      }
      return {
        ...state,
        pme: {
          ...state.pme,
          data,
        }
      }
    case types.PME_DASHBOARD_SUCCESS:
      return {
        ...state,
        pme: {
          retrived: true,
          data: {
            ...state.pme.data,
            ...action.value,
          },
        },
      }
    default:
      return state;
  }
};
